import mock from 'api/mock';

mock.onPost('/consents/b2v').reply(() => {
    return [200, 'OK'];
});
